<template>
  <v-card>
    <v-card-title>
      <span>{{ alert.name }}</span>
    </v-card-title>
    <v-card-text>
      <div
        class="alertcontainer"
        v-bind:style="{ 'border-color': borderColor }"
      >
        <v-container>
          <ScreeningAlertText :alert="alert" />
        </v-container>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from '../../services/axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
import ScreeningAlertText from './ScreeningAlertText'

export default {
  name: 'ScreeningAlertComponent',

  mixins: [],

  props: {
    alert: {
      type: Object
    }
  },

  components: {
    ScreeningAlertText
  },

  mounted() {},

  watch: {},

  data() {
    return {}
  },

  computed: {
    buttonsColor() {
      return this.$vuetify.theme.dark ? 'white' : 'grey darken-3'
    },
    borderColor() {
      switch (this.alert.type) {
        case 'MANEUVER':
          return 'green'
        case 'CLOSE_APPROACH':
          return 'gold'
        case 'ORBIT_INSERTION':
          return 'blue'
        default:
          return 'black'
      }
    }
  },

  methods: {}
}
</script>

<style scoped>
.alertcontainer {
  border: solid;
  margin-bottom: 2px;
  border-radius: 10px;
}
</style>
